export default __webpack_public_path__ + "static/media/add-block.932c65ec.svg";